import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { inject, observer } from 'mobx-react';
import DataTable from '../core/components/datatable/DataTable';
import { useComponentDidMount } from '../core/hooks';
import {
  orderActions,
  OrderStore,
  Order1C,
  Order1CItem,
} from '../orders/store/orders/orderStore';

interface Client1COrdersProps {
  clientId: string,
  orderStore?: Pick<OrderStore, 'clientOrders1C' | 'clientOrders1CByClientId'>,
}

// Список позиций заказа из 1С в одной ячейке (по образцу FeesCell).
const formatNumber = (value?: number): string => (value != null
  ? value.toFixed(2).replace('.', ',')
  : '');

const Order1CItemsCell = ({ items }: { items?: Order1CItem[] }) => {
  if (!items || items.length === 0) {
    return <span className='text-muted small'>—</span>;
  }

  return (
    <table className='table table-sm table-borderless mb-0' style={ { width: 'auto' } }>
      <tbody>
        { items.map((item, index) => (
          <tr key={ item?.guid ?? index }>
            <td className='p-0 pr-2 small text-nowrap text-right border-0 '>{ item?.count } шт. -</td>
            <td className='p-0 pr-2 small text-nowrap border-0'>{ item?.name }  -</td>
            <td className='p-0 small text-nowrap text-right border-0 font-weight-bold'> { formatNumber(item?.sum) } ₽</td>
            { /* <td className='p-0 pr-2 small text-nowrap text-right border-0 font-weight-bold'>{ formatNumber(item?.price) }</td> */ }
          </tr>
        )) }
      </tbody>
    </table>
  );
};

const Client1COrders = (props: Client1COrdersProps) => {
  const {
    orderStore,
    clientId,
  } = props;

  const { clientOrders1C, clientOrders1CByClientId } = orderStore;

  const [loading, setLoading] = useState(false);

  const columns = [
    { title: 'Номер заказа', name: 'ordernumber', width: 150 },
    { title: 'Дата заказа', name: 'orderdate', width: 180 },
    { title: 'Статус', name: 'orderstatus', width: 120 },
    { title: 'Сумма', name: 'ordersum', width: 120 },
    {
      title: 'Позиции',
      name: 'items',
      width: 640,
      getCellValue: (row: Order1C) => <Order1CItemsCell items={ row?.items } />,
    },
  ];

  const loadData = async (request: string) => {
    setLoading(true);
    await orderActions.getOrders1C(request);
    setLoading(false);
  };

  useComponentDidMount(() => {
    if (clientOrders1CByClientId !== clientId) { loadData(clientId); }
  });

  return (
    <Col md={ 12 }>
      <Row>
        { (clientOrders1CByClientId === clientId)
        && (
          <Col md={ 12 }>
            <DataTable
              loading={ loading }
              data={ clientOrders1C || [] }
              columns={ columns }
              localPaging
              localSorting
              hideToolbar
            />
          </Col>
        ) }
      </Row>
    </Col>
  );
};

export default inject('orderStore')(observer(Client1COrders));
